import type { ReportComponentTheme } from "./reportPresentation";

export interface ReportTheme extends ReportComponentTheme {
  primaryColor: string;
  logoUrl?: string | null;
  fontFamily?: string | null;
  chartPalette?: [string, string, string, string, string];
}

/** Matches app `--primary` (naapp violet brand). */
export const DEFAULT_REPORT_THEME: ReportTheme = {
  primaryColor: "var(--primary)",
};

export const REPORT_CSS_VAR_PRIMARY = "--report-primary";
